module.exports = __webpack_public_path__ + "img/dataCensus_profit.1bbaad6d.svg";